<template>
  <header class="header bg-white shadow py-4 px-4">
    <div class="header-content flex items-center flex-row">
      <div class="hidden md:flex relative">
        <div class="flex border-2 border-gray-200 rounded">
          <input
            type="text"
            class="px-4 py-2 sm:w-40 md:w-80"
            v-on:keyup.enter="filterBarSearch()"
            v-model="searchText"
            placeholder="Search..."
          />
          <button class="px-4 text-white bg-blue-700 border-l rounded" @click="filterBarSearch()">
            <i class="fas fa-search" />
          </button>
        </div>
      </div>
      <div class="flex ml-auto">
        <list-view-sort />
      </div>
    </div>
    <div class="flex items-center flex-row pt-4">
      <div class="text-tiny lg:text-xs bg-blue-800 self-end pill-xs sm:pill-sm mx-2" v-if="currentSearch.SearchCriteria.text">
        {{ currentSearch.SearchCriteria.text }}
        <button @click="clearSearchText()"><i class="fas fa-close pl-2" /></button>
      </div>
      <div class="text-tiny lg:text-xs bg-blue-800 self-end pill-xs sm:pill-sm mx-2" v-if="currentSearch.SearchCriteria.ResourceType">
        {{ currentSearch.SearchCriteria.ResourceType }}
        <button @click="removeResourceType()"><i class="fas fa-close pl-2" /></button>
      </div>
      <div
        class="text-tiny lg:text-xs bg-blue-800 self-end pill-xs sm:pill-sm mx-2"
        v-for="cat in currentSearch.SearchCriteria.categories"
        :key="cat"
      >
        {{ cat }}
        <button @click="removeCategory(cat)"><i class="fas fa-close pl-2" /></button>
      </div>
    </div>
  </header>
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import ListViewSort from '@/components/list-view-components/ListViewSort'

export default {
  name: 'ListViewFilterBar',
  components: { ListViewSort },
  setup() {
    const store = useStore()

    const searchText = ref(null)

    const currentSearch = computed(() => {
      return store.getters['Resources/currentRequest']
    })

    function removeCategory(identifier) {
      store.dispatch('Resources/removeCategory', identifier)
    }
    function removeResourceType() {
      store.dispatch('Resources/removeResourceType')
    }
    function filterBarSearch() {
      const request = JSON.parse(JSON.stringify(currentSearch.value))
      request.SearchCriteria.text = searchText.value
      searchText.value = null
      store.dispatch('Resources/search', request)
    }
    function clearSearchText() {
      searchText.value = null
      filterBarSearch()
    }

    return { searchText, currentSearch, removeCategory, filterBarSearch, clearSearchText, removeResourceType }
  },
}
</script>

<style scoped>

</style>
